import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import StorageForm from '../Form';
import { fetchStorage, updateStorage } from '@resources/Storage/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const {
		module,
		fetchStorage,
		storage,
		updateStorage,
		visible,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchStorage(visible);
		};
		visible && fetchData();
	}, [fetchStorage, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateStorage(storage._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.storage.update',
							defaultMessage:
								'An existing Storage entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[storage]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.storage',
					defaultMessage: 'Update Storage',
				})}
			</Title>
			{!isEmpty(storage) && (
				<StorageForm
					data={storage}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	storage,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		storage,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchStorage,
	updateStorage,
})(Update);
